const actions = {
    CREATE_PRODUCT_REQUEST: 'CREATE_PRODUCT_REQUEST',
    CREATE_PRODUCT_SUCCESS: 'CREATE_PRODUCT_SUCCESS',
    CREATE_PRODUCT_ERROR: 'CREATE_PRODUCT_ERROR',
    CREATE_PRODUCTS_REQUEST: 'CREATE_PRODUCTS_REQUEST',
    CREATE_PRODUCTS_SUCCESS: 'CREATE_PRODUCTS_SUCCESS',
    CREATE_PRODUCTS_ERROR: 'CREATE_PRODUCTS_ERROR',
    READ_PRODUCTS_REQUEST: 'READ_PRODUCTS_REQUEST',
    READ_PRODUCTS_SUCCESS: 'READ_PRODUCTS_SUCCESS',
    READ_PRODUCTS_ERROR: 'READ_PRODUCTS_ERROR',
    SET_PRODUCT_IN_SET: 'SET_PRODUCT_IN_SET',
    READ_PRODUCT_REQUEST: 'READ_PRODUCT_REQUEST',
    READ_PRODUCT_SUCCESS: 'READ_PRODUCT_SUCCESS',
    READ_PRODUCT_ERROR: 'READ_PRODUCT_ERROR',
    UPDATE_PRODUCT_REQUEST: 'UPDATE_PRODUCT_REQUEST',
    UPDATE_PRODUCT_SUCCESS: 'UPDATE_PRODUCT_SUCCESS',
    UPDATE_PRODUCT_ERROR: 'UPDATE_PRODUCT_ERROR',
    ARCHIVE_PRODUCT_REQUEST: 'ARCHIVE_PRODUCT_REQUEST',
    ARCHIVE_PRODUCT_SUCCESS: 'ARCHIVE_PRODUCT_SUCCESS',
    ARCHIVE_PRODUCT_ERROR: 'ARCHIVE_PRODUCT_ERROR',
    DELETE_PRODUCT_REQUEST: 'DELETE_PRODUCT_REQUEST',
    DELETE_PRODUCT_SUCCESS: 'DELETE_PRODUCT_SUCCESS',
    DELETE_PRODUCT_ERROR: 'DELETE_PRODUCT_ERROR',
    CHANGE_PRODUCT: 'CHANGE_PRODUCT',
    CHANGE_IS_SELLING: 'CHANGE_IS_SELLING',
    CHANGE_IS_BUYING: 'CHANGE_IS_BUYING',
    CHANGE_SHOW_CUSTOM_SALE_PRICES: 'CHANGE_SHOW_CUSTOM_SALE_PRICES',
    CHANGE_SHOW_CUSTOM_PURCHASE_PRICES: 'CHANGE_SHOW_CUSTOM_PURCHASE_PRICES',
    PRODUCT_SET_TRACK_INVENTORY: 'PRODUCT_SET_TRACK_INVENTORY',

    PRODUCT_SET_NAME: 'PRODUCT_SET_NAME',
    PRODUCT_SET_CLASSIFICATION_CODE: 'PRODUCT_SET_CLASSIFICATION_CODE',

    PRODUCT_RESET_STATE: 'PRODUCT_RESET_STATE',

    // Bulk update product
    BULK_UPDATE_PRODUCTS_REQUEST: 'BULK_UPDATE_PRODUCTS_REQUEST',
    BULK_UPDATE_PRODUCTS_SUCCESS: 'BULK_UPDATE_PRODUCTS_SUCCESS',
    BULK_UPDATE_PRODUCTS_ERROR: 'BULK_UPDATE_PRODUCTS_ERROR',
    READ_BULK_PRODUCTS_REQUEST: 'READ_BULK_PRODUCTS_REQUEST',
    READ_BULK_PRODUCTS_SUCCESS: 'READ_BULK_PRODUCTS_SUCCESS',
    READ_BULK_PRODUCTS_ERROR: 'READ_BULK_PRODUCTS_ERROR',

    OPEN_PRODUCT_CARD_REQUEST: 'OPEN_PRODUCT_CARD_REQUEST',
    OPEN_PRODUCT_CARD_SUCCESS: 'OPEN_PRODUCT_CARD_SUCCESS',
    OPEN_PRODUCT_CARD_ERROR: 'OPEN_PRODUCT_CARD_ERROR',

    READ_PRODUCT_CARD_PAST_TXNS_REQUEST: 'READ_PRODUCT_CARD_PAST_TXNS_REQUEST',
    READ_PRODUCT_CARD_PAST_TXNS_SUCCESS: 'READ_PRODUCT_CARD_PAST_TXNS_SUCCESS',
    READ_PRODUCT_CARD_PAST_TXNS_ERROR: 'READ_PRODUCT_CARD_PAST_TXNS_ERROR',
    CLOSE_PRODUCT_CARD: 'CLOSE_PRODUCT_CARD',

    MERGE_PRODUCT_REQUEST: 'MERGE_PRODUCT_REQUEST',
    MERGE_PRODUCT_SUCCESS: 'MERGE_PRODUCT_SUCCESS',
    MERGE_PRODUCT_ERROR: 'MERGE_PRODUCT_ERROR',
    SET_PRODUCT_TABLE_IDS: 'SET_PRODUCT_TABLE_IDS',

    SET_IMPORT_HEADER_ROW_LINE_COUNT: 'SET_IMPORT_HEADER_ROW_LINE_COUNT',

    BULK_DELETE_PRODUCTS_REQUEST: 'BULK_DELETE_PRODUCTS_REQUEST',
    BULK_DELETE_PRODUCTS_SUCCESS: 'BULK_DELETE_PRODUCTS_SUCCESS',
    BULK_DELETE_PRODUCTS_ERROR: 'BULK_DELETE_PRODUCTS_ERROR',

    createProduct: request => ({
        type: actions.CREATE_PRODUCT_REQUEST,
        request,
    }),
    createProducts: request => ({
        type: actions.CREATE_PRODUCTS_REQUEST,
        request,
    }),
    readProducts: request => ({
        type: actions.READ_PRODUCTS_REQUEST,
        request,
    }),
    setProductInSet: product => ({
        type: actions.SET_PRODUCT_IN_SET,
        product,
    }),
    readProduct: id => ({
        type: actions.READ_PRODUCT_REQUEST,
        id,
    }),
    updateProduct: (id, request) => ({
        type: actions.UPDATE_PRODUCT_REQUEST,
        id,
        request,
    }),
    archiveProduct: (id, request) => ({
        type: actions.ARCHIVE_PRODUCT_REQUEST,
        id,
        request,
    }),
    deleteProduct: id => ({
        type: actions.DELETE_PRODUCT_REQUEST,
        id,
    }),

    setProductName: name => ({
        type: actions.PRODUCT_SET_NAME,
        name,
    }),
    setClassificationCode: classificationCode => ({
        type: actions.PRODUCT_SET_CLASSIFICATION_CODE,
        classificationCode,
    }),

    // Bulk update product
    bulkUpdateProducts: request => ({
        type: actions.BULK_UPDATE_PRODUCTS_REQUEST,
        request,
    }),
    readBulkProducts: request => ({
        type: actions.READ_BULK_PRODUCTS_REQUEST,
        request,
    }),

    changeProduct: (request, reset = false) => ({
        type: actions.CHANGE_PRODUCT,
        request,
        reset,
    }),
    changeIsSelling: isSelling => ({
        type: actions.CHANGE_IS_SELLING,
        isSelling,
    }),
    changeIsBuying: isBuying => ({
        type: actions.CHANGE_IS_BUYING,
        isBuying,
    }),
    changeShowCustomSalePrices: isEnabled => ({
        type: actions.CHANGE_SHOW_CUSTOM_SALE_PRICES,
        isEnabled,
    }),
    changeShowCustomPurchasePrices: isEnabled => ({
        type: actions.CHANGE_SHOW_CUSTOM_PURCHASE_PRICES,
        isEnabled,
    }),
    setTrackInventory: trackInventory => ({
        type: actions.PRODUCT_SET_TRACK_INVENTORY,
        trackInventory,
    }),
    resetState: () => ({
        type: actions.PRODUCT_RESET_STATE,
    }),

    openProductCard: id => ({
        type: actions.OPEN_PRODUCT_CARD_REQUEST,
        id,
    }),
    readProductCardPastTxn: (id, request) => ({
        type: actions.READ_PRODUCT_CARD_PAST_TXNS_REQUEST,
        id,
        request,
    }),
    closeProductCard: () => ({
        type: actions.CLOSE_PRODUCT_CARD,
    }),
    mergeProducts: request => ({
        type: actions.MERGE_PRODUCT_REQUEST,
        request, // { product_ids: [1,2,3], merge_id: 1, merge_uom: true}
    }),
    setProductTableIds: ids => ({
        type: actions.SET_PRODUCT_TABLE_IDS,
        ids,
    }),

    setImportHeaderRowLineCount: headerRowLineCount => ({
        type: actions.SET_IMPORT_HEADER_ROW_LINE_COUNT,
        count: headerRowLineCount, // number of header rows in the xlsx file
    }),

    bulkDeleteProducts: ids => ({
        type: actions.BULK_DELETE_PRODUCTS_REQUEST,
        product_ids: ids, // array of product ids to delete
    }),
};
export default actions;
